import { CheckboxButtonSelected, CheckboxButtonUnselected } from '../../shared/CheckboxButton'

/**
 * Componente checkbox customizzabile
 *
 * @param {Object} input - Propriet  dell'input
 * @param {string} label - L'etichetta della checkbox
 * @param {Function} onChange - La funzione da chiamare quando la checkbox viene modificata
 * @param {string} name - Il nome della checkbox
 * @param {boolean} checked - Lo stato di selezione della checkbox
 * @param {Object} error - L'oggetto di errore
 * @param {boolean} disabled - Se true la checkbox è disabilitata
 */
export const BwmCheckbox = ({ input, label, onChange, name, checked, error, disabled }) => (
  <div>
    <div className="input-group">
      {checked && (
        <input
          hidden={true}
          {...input}
          type="checkbox"
          className="form-check-input"
          name={name}
          id={name}
          onChange={onChange}
          checked={true}
          disabled={disabled}
        />
      )}
      {!checked && (
        <input
          hidden={true}
          {...input}
          type="checkbox"
          className="form-check-input"
          name={name}
          id={name}
          onChange={onChange}
          disabled={disabled}
        />
      )}
      <label
        className={`form-check-label cursor-pointer ${checked ? 'font-weight-bold' : ''}`}
        htmlFor={name}>
        {checked ? <CheckboxButtonSelected /> : <CheckboxButtonUnselected />}
        {label}
      </label>
    </div>
    {error !== undefined && error !== null && !error.isValid ? (
      <div className="text-danger">{error.msg}</div>
    ) : (
      ''
    )}
  </div>
)
